class MessageOutboundSettingsController {
  /* @ngInject */
  constructor(MerchantConfigurationService, $log) {
    this.loading = {
      settings: false
    };

    this.settings = {
      message: {
        enabled: false
      },
    };

    const loadSettings = () => {
      if (this.loading.settings) return;
      this.loading.settings = true;
      MerchantConfigurationService.getCheckinConfiguration().then((settings) => {
        this.settings = settings;
      }, (reason) => {
        $log.error('CheckinSettingsController', 'loadSettings', reason);
      }).finally(() => {
        this.loading.settings = false;
      });
    };

    const init = () => {
      loadSettings();
    };

    this.$onInit = init;

    this.save = () => {
      if (this.loading.settings) return;
      this.loading.settings = true;
      MerchantConfigurationService.setMessageOutboundConfiguration(this.settings).then(loadSettings, (reason) => {
        $log.error('CheckinSettingsController', 'save', reason);
      }).finally(() => {
        this.loading.settings = false;
      });
    };

    this.reset = loadSettings;
  }
}

export default MessageOutboundSettingsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/settings/settings.controller.js
 **/